const FALLBACK_TEMPLATE = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";

const toHex = (segment: Uint8Array) =>
  Array.from(segment, (byte) => byte.toString(16).padStart(2, "0")).join("");

const getGlobalCrypto = () =>
  typeof globalThis === "undefined" ? undefined : globalThis.crypto;

const randomUUID = () => {
  const globalCrypto = getGlobalCrypto();

  if (globalCrypto?.randomUUID) {
    return globalCrypto.randomUUID();
  }

  if (globalCrypto?.getRandomValues) {
    const bytes = globalCrypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6]! & 0x0f) | 0x40;
    bytes[8] = (bytes[8]! & 0x3f) | 0x80;

    return [
      toHex(bytes.subarray(0, 4)),
      toHex(bytes.subarray(4, 6)),
      toHex(bytes.subarray(6, 8)),
      toHex(bytes.subarray(8, 10)),
      toHex(bytes.subarray(10, 16)),
    ].join("-");
  }

  return FALLBACK_TEMPLATE.replace(/[xy]/g, (char) => {
    const random = Math.random() * 16;
    const value = char === "x" ? random : (random & 0x3) | 0x8;
    return Math.floor(value).toString(16);
  });
};

export default randomUUID;
